import React, { Component } from 'react'
import { connect } from 'react-redux'
import withTranslationWrapper from '../../HOC/HocTranslate'
import Layout from './../../wrapper'
import { ShowReports } from '../../Components/Reports/showReports'
import { logInUserInfo } from '../../Actions/Users'
import { checkPrivileges, isOwnerOrDealer } from '../../Helpers'
import { notifyError, notifySuccess } from '../../Utils/CustomNotifcations'
import withRoutes from '../../HOC/HocRoutes'
import { apiFetch } from '../../Utils/apiFetch'

class SystemLogs extends Component {
  constructor (props) {
    super(props)
    this.state = {
      userInfo: {},
      userFetch: false
    }
  }

  render () {
    if (checkPrivileges('report')) {
      if (this.props.logInUser && this.props.logInUser.userType === -1) {
        return (
          <Layout
            {...this.props}
            noSidebar
          >
            <ShowReports />
          </Layout>
        )
      } else {
        apiFetch('/api/session?app=2bd5bd10345cd1555b14c221ec6e8647c46ee21e8ee45312', {
          headers: { Accept: 'application/json; odata=verbose' }
        }).then(response => {
          if (response.ok) {
            response.json().then(res => {
              if(res.status ==='success'){ 
                let userInfo = res.data
                this.props.setActiveLanguage(userInfo?.attributes?.lang || 'en')
                this.props.dispatch(logInUserInfo(userInfo))
              }
              else if(res?.statusCode === '440'){
                window.location.replace('/login')
              }
              else if(res.statusCode){
                var err = res?.message.split(':')
                err[1] =err[1].replace(')', "")
                this.props.dispatch(
                  notifyError(err[1])
                )
                this.props.navigate('/logout')
              }
            })
          } else {
            this.props.navigate('/logout')
              throw response
            }
          })
          .catch(e => {
            this.props.dispatch(notifyError('somethingWentWrong'))
          })
        return null
      }
    } else {
      return <h1>Page Not Found</h1>
    }
  }
}

const mapStateToProps = state => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers
})

export default connect(mapStateToProps)(withRoutes(withTranslationWrapper(SystemLogs)))
